import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '返回参数',
    type: 'ALG_OUTPUT',
}
